import { Blog } from "@types"

import { host as paragraphHost } from "lib/api/constants"

/**
 * Contains all the different variations of a blog URL you might want to use.
 */
type BlogUrlDetails = {
  url: string
  host: string
  fullUrl: string
  customDomainOrRelativeUrl: string
}

/*
 * Function to get blog URL.
 */
export function getBlogUrl(
  blog?: Pick<Blog, "custom_domain" | "lowercase_url">
): BlogUrlDetails {
  if (!blog)
    return { url: "", host: "", fullUrl: "", customDomainOrRelativeUrl: "" }

  const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
  const useCustomDomain = isProduction && blog.custom_domain

  const url = useCustomDomain ? "/" : `/${blog.lowercase_url}/`

  let host

  if (useCustomDomain) {
    host = `https://${blog.custom_domain}`
  } else {
    host = paragraphHost
  }

  const customDomainOrRelativeUrl = useCustomDomain
    ? "/"
    : `/${blog.lowercase_url}/`

  const fullUrl = `${host}${url}`

  return { url, host, fullUrl, customDomainOrRelativeUrl }
}
